import http from "./http-common";
import JWT from "./Jwt";
import Crypto from "./Crypto";
import {getServidorPorAmbiente } from "../utils/Utils";



/**
 * @brief Clase del servicio de acciones que permite consultar las acciones registradas
 */

class AccionesDataService {


  /** 
   * @brief Listado de todas las acciones registradas
   * @returns {Promise<AxiosResponse<any>>} lista de las acciones
   */
  getAll() {
    return http.get(`${getServidorPorAmbiente()}/acciones/`);
  }

  /**
   * @brief Método que permite registrar una accion
   * @param data datos de la accion
   * @param key key de encriptar
   * @returns {Promise<AxiosResponse<any>>} Respuesta de la petición.
   */
  async create(data, key) {
    const datosEncriptados = await Crypto.encriptar(data, key);
    return http.post(`${getServidorPorAmbiente()}/acciones/`,datosEncriptados, {
      showLoader: false});
  }

  /**
   * @brief Historial completo de acciones por fecha
   * @param data Datos utilizados para consultar el historial.
   * @param key Clave utilizada para encriptar los datos.
   * @returns {Promise<AxiosResponse<any>>} Respuesta de la petición.
   */
  async getAllByDate(data, key) {
    const datosEncriptados = await Crypto.encriptar(data, key);
    return http.get(`${getServidorPorAmbiente()}/acciones/fecha/`, {
      params: datosEncriptados
    });
  }

  /**
   * @brief Historial de acciones por filtro(log de acciones, configuracion) y por fecha
   * @returns {Promise<AxiosResponse<any>>} Respuesta de la petición.
   */
  getAllByFiltro() {
    return http.get("/acciones/filtro/" + "?fecha_inicial=" + JWT.jwtEncode(sessionStorage.fechaIniLog) +
      "&fecha_final=" + JWT.jwtEncode(sessionStorage.fechaFinLog) + "&filtro=" + JWT.jwtEncode(sessionStorage.filtro));
  }

  /**
   * @brief Valida si existe un token en la lista de tokens permitido.
   * @returns {Promise<boolean>} true si el token existe y es válido;
   */
  async validarTokenExistenteAllowList() {
    const resp = await http.post(`${getServidorPorAmbiente()}/api/auth/validar-token`);
    return resp.data === true;
  }


}
/**
 * @brief Instancia del servicio de acciones.
 * @type {AccionesDataService}
 */
export default new AccionesDataService();